import type { JSX } from "react";

import {
  LocationResolutionFilterData,
  LocationResolutionFilterMetadata,
  LocationResolutionType,
} from "@/types/playground";

import { PostalCodeMetadata } from "./PostalCodeMetadata";

export type LocationTypeGroupFilterOptionMetadataProps = {
  postalCode: string;
  setPostalCode: (postalCode: string) => void;
  onEnterPostalCodeValue: () => void;
  locationResolutionType: LocationResolutionType;
  locationResolution: LocationResolutionFilterData;
  onLocationResolutionMetadataChange: (metadata: LocationResolutionFilterMetadata) => void;
};

export const LocationTypeGroupFilterOptionMetadata = ({
  postalCode,
  setPostalCode,
  onEnterPostalCodeValue,
  locationResolutionType,
  locationResolution,
  onLocationResolutionMetadataChange,
}: LocationTypeGroupFilterOptionMetadataProps): JSX.Element | undefined => {
  if (locationResolutionType === LocationResolutionType.PostalCode) {
    return (
      <PostalCodeMetadata
        metadata={locationResolution.metadata}
        onLocationResolutionMetadataChange={onLocationResolutionMetadataChange}
        postalCode={postalCode}
        setPostalCode={setPostalCode}
        onEnterPostalCodeValue={onEnterPostalCodeValue}
      />
    );
  }
};
